import axios from 'axios';

const getVideoAnalyticsMetadata = (mediaID) => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    url: `${process.env.REACT_APP_VIDEO_ANALYTICS_URL}&id=${mediaID}`,
  };
  return axios(requestOptions);
};

const getPageAnalyticsMetadata = (mediaID, source) => {
  let reqURL = `${process.env.REACT_APP_PAGE_ANALYTICS_URL}&path=/embedplayer/${mediaID}`;
  if (source) reqURL = `${reqURL}/${source}`;

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    url: reqURL,
  };
  return axios(requestOptions);
};

export const analyticsServices = {
  getVideoAnalyticsMetadata,
  getPageAnalyticsMetadata,
};
